import React, { useEffect, useState, useRef } from "react";
import Accordion from 'react-bootstrap/Accordion';
import {
  
  Container,
  Row,
  Col,
 
} from "react-bootstrap";


export const Faq = () => {

  const [searchQuery, setSearchQuery] = useState('');

  // Replace the static accordionItems with your array of questions and answers
  const accordionItems = [
    {
      question: "How do I create an account?",
      answer: '1. Visit www.hescocrane.com. \n2. Click the Log In button at the top right of the page. If you are using a mobile device, click the three vertical lines on the top left portion of the screen and select LOG IN. \n3. Click the SIGN UP button in BLUE at the bottom of the page.  \n4. Enter the appropriate information and click Next, enter the billing information and yard address. Click next. Enter the decal information which tells us where you would our office to send an inspection sticker to adhere to your device. Click submit. You will receive an email confirmation. ',
    },
    {
      question: "How can I change my password? ",
      answer: `1. Log In by clicking the LOG IN button at the top right of our website www.hescocrane.com.
      2. Enter your email address and password that you created when registering for access to the portal.
      3. Click the upper righthand corner of the screen where it displays your name and avatar.
      4. After a dropdown appears, click Profile.
      5. Click the yellow "Change Password" button on the upper right hand part of the screen.
      6. Follow the instructions on the screen and click submit.`,
    },
    {
      question: "How do I update my profile information? ",
      answer: `1. Email our offices by clicking the "Contact" button at the top of the page. 
      2. Provide details about the necessary changes to update your profile. 
      3. Click Submit
      4. We will notify you when the changes are live.`,
    },
    {
      question: 'How do I deactivate my account?',
      answer: ` Email our offices at inspection@hescocrane.com and write a message that includes: \n1. Company Name, \n2. Primary Contact Name \n3. Your Name & Position \n4. A written request to cancel your account via email. You will no longer be able to acccess your company files. `,
    },
    {
      question: "How can I view the devices you've inspected?",
      answer: `1. Click the Dashboard button at the very top of the screen
      2. Click the Green tile named "Certificates" and it will automatically take you to a page with an index of your machines.
      3. If you have several machines, use the search fields above to locate your device more efficiently.`,
    },
    {
      question: "Where can I download the inspection certificates for my devices? ",
      answer: `1. Click the green "Certificates" tile on your dashboard
      2. Search or locate the machine of interest.
      3. Click the Arrow Down icon on the right hand side of it.
      4. Alternatively, we email a copy of every certificate as soon as it is issued. `,
    },
    {
      question: "How do I view upcoming scheduled inspections?",
      answer: `1. Click the "Dashboard" button on the top left part of the screen.
      2. Scroll down to the section titled "Upcoming Inspections"`,
    },
    {
      question: "Can I customize my dashboard?",
      answer: `In order to provide you a seamless and organized experience, we do not allow any customizations of your dashboard. This allows us to effectively assist with any issues you may be having with the system.`,
    },
   
    {
      question: "How will my inspection documents be shared with me and can I share inspection documents with others?",
      answer: `1. Download the pdf copy of the document and attach it to an email.
      2. Alternatively, you can add members to your organization so that they have access to our portal.
      3. To avoid confusion, I highly recommend only adding employees to your portal, not outside third-parties.`,
    },
    {
      question: "Can I view the history of all past inspections?",
      answer: `Yes.
      1. Click the "Dashboard" button at the top left of your screen
      2. Go to "Scheduled Inspections" section
      3. Choose the appropriate date range
      4. Choose the Service Request of interest to look at the details of the inspection.`,
    },
    {
      question: "What if a deficiency report has been issued for my device?",
      answer: `1. In order for us to certify your machine and send you a certificate, you need to mitigate the deficiencies listed.
      2. You can click the red tile at the top of the page "Outstanding Deficiencies".
      3. This will automatically scroll you down to the machines that still have outstanding deficiencies. 
      4. You can sign off on the deficiencies through our portal by clicking the signature icon on the right hand side of the screen. A witness must also sign the witness section.
      5. Alternatively, you can download, print, sign and email it back to us at inspection@hescocrane.com`,
    },
    {
      question: "What do I do with the deficiency report?",
      answer: `1. You must address the issues cited in the deficiency report and affirm that they have all been mitigated before we can issue a certificate of inspection. 
      2. Once all deficienies have been repaired or mitigated, please date when each issue was fixed. Sign and have a witness sign the report. Send back to us through the portal or you may print, sign and email it back to us. 
      3. When you or someone from your organization dates and signs a deificiency report, you are legally affirming that you or someone in your organization made the appropriate repairs or mitigations regarding the citations we issued on your report. We assume no responsibility regarding the credibility of the repairs or changes made to your device to address the listed deficiencies in your report. Your sign-off affirms that your organization has taken full responsibility to address and fix the deficiencies cited in the report. If you have any questions, you make contact our office at 860-739-4446`,
    },
    {
      question : "How long are our inspections valid for? How do I see when my device certifications will expire?",
      answer:"1. Our Annual Crane Inspections are valid for 1 year from the day that the inspection was performed"
    },
    {
      question : "What should I do if a crane is nearing its inspection expiry date?",
      answer:`1. We advise that you schedule reinspection 2 weeks prior to your expiration date to increase your chances of getting the desired date and time slot.`
    },
    {
      question : "Will I be notified of upcoming inspections?",
      answer:`You should receive a notice 1 month prior to your device's expiration, but do not rely solely on our system. Please check your documents and verify the expiration date to ensure your device does not lapse.`
    },
    {
      question : "Can I reschedule an inspection?",
      answer : `You may call our office and reschedule your inspection at least 48 hours before the inspection was originally scheduled`
    },
  
    {
      "question": "How do I add new team members to my organization's account?",
      "answer": "Send an email to our office using the contact button at the top of the page with the following information about the NEW:\n1. Your Company Name\n2. First & Last Name of New User\n3. Email\n4. Contact Number\n5. Their Role or Designation in the Company\n6. Any notes you would like to attach to this user.\n\nWe will create their profile and send them an email inviting them to create a password."
    },
    {
      "question": "How do I remove a team member?",
      "answer": "Send an email to our office using the contact button at the top of the page with the following about the user you would like to delete:\n1. Company Name\n2. First & Last Name of New User\n3. Position or Title\n4. Email"
    },
    {
      "question": "Is there a mobile version or app for the portal?",
      "answer": "Yes, Our Inspection document portal is mobile-friendly.\n1. Visit hescocrane.com and click the log in button on the navigation panel.\n2. Sign in with your registered email address."
    },
    {
      "question": "Can I download a copy of my invoices?",
      "answer": "Yes, we will attach a copy of the invoice to your inspection. Currently, there is no way to pay the invoice through our portal."
    },
    {
      "question": "Can I pay my invoices directly through the portal?",
      "answer": "No. You can pay through the QuickBooks email you receive when we send you the invoice."
    },
    {
      "question": "Why are we transitioning to a new system? What are the key features?",
      "answer": "1. Improved Security and a more centralized source of inspection information (Certificates, Deficiency Reports, Expiration Dates, Scheduled Inspections)\n2. Our new portal provides improved access and searchability of your documents. For example, you can now search by model, serial number, date, certificate number, or device id.\n3. You can actively see your expiration dates to stay current on all inspections.\n4. Request an inspection directly through the portal and we preserve all machine information for easy reference.\n5. You get a downloadable copy of each inspection via email as well as Dropbox access via Dropbox link. This is all in addition to using our Inspection Portal.\n6. You will get automated reminders for: 1) Outstanding deficiency reports to help prevent you from leaving equipment uncertified and 2) Upcoming expirations.\n7. You may access invoice copies via the Service request for a job.\n8. You can efficiently sign a deficiency report in our inspection portal to expedite the certification process and eliminate paper waste.\n9. You are notified when changes are made to a scheduled inspection.\n10. We can easily transfer ownership of a crane to another company when it is no longer in your fleet.\n11. Jobsite photos now may be attached to each inspection."
    },
    // {
    //   "question": "Can I access the old system?",
    //   "answer": "No, we are transitioning to the new system, and the old system is no longer accessible."
    // },
    {
      "question": "Can I still access my files via Dropbox?",
      "answer": "Yes, if you choose not to register or log in to our new system, you will receive Dropbox links every time we issue documents. These Dropbox links will function similarly to our previous system."
    },
    {
      "question": "How can I search for files in the new system?",
      "answer": "We have improved searchability and sorting functions in your portal under the active certificates tab."
    },
    {
      "question": "Dropbox looks different now. What changed?",
      "answer": "We now organize your inspections by year and then by type. This is more efficient when locating an inspection document."
    },
    {
      "question": "How do I schedule a crane inspection?",
      "answer": "You have multiple options for scheduling a crane inspection:\n\nOption 1. Call our office at 860-739-4446 and schedule it with one of our office staff\nOption 2. Send an email to inspection@hescocrane.com\nOption 3. Go to the HESCO Inspection Portal on a desktop or mobile device at www.hescocrane.com. Click the Log In button at the upper right-hand part of the webpage. Enter your registered email and password. Now, click the 'New Inspection Request' button. On a mobile device, the Inspection Request Button will be at the top of the screen. On a desktop computer, the 'New Inspection Request' button is in the upper-right-hand portion of the page. Now enter all of your necessary information in the fields and click submit. Our office will be notified and will contact you to confirm the details."
    },
    {
      "question": "Where can I find my expiration date?",
      "answer": "There are two different ways to access this information, on a mobile device or desktop.\n\nDESKTOP DEVICE: When accessing on a desktop, please log into the Hesco Inspection Portal, 1) click the INSPECTIONS section at the top of the page. The screen will display a list of inspected devices, and on the 6th column from the left side of the page, you will see INSPECTION DATE. This is the date on which the device was inspected. The inspection is valid for 1 year from this date, meaning that the device will expire exactly ONE year from the inspection date.\n\nMOBILE DEVICE: 1) Log in and click the three horizontal lines at the top of the page. A little tip to make it easier to read the screen, turn your phone to landscape view, and the display will increase in size. Select INSPECTIONS from the dropdown. You can manually scroll from right to left to access the different inspection details regarding this machine. INSPECTION DATE is the date on which we inspected the device. The inspection is valid for exactly 1 year from this date, meaning that the device will expire exactly ONE year from the inspection date."
    },
    {
      "question": "What should I do if I forget my password or username?",
      "answer": "1. Visit the login screen on a DESKTOP COMPUTER by clicking LOG IN at the top right of the screen or on a MOBILE DEVICE, click the three horizontal bars on the lefthand side of the screen. Now, click the 'forgot password' button. It will prompt you to enter the email address that you originally registered with our portal. A password change request will be sent to your inbox, and follow the instructions."
    },
    {
      "question": "How can I update my account information?",
      "answer": "Email our office at Inspection@hescocrane.com with the appropriate changes to your account."
    },
    {
      "question": "What are your hours of operation?",
      "answer": "Our office is typically open from 8 am to 5 pm, but we are a service-based company, so we may be out in the field. You should try reaching us via email at inspection@hescocrane.com if we do not answer your call. As far as inspection times, we inspect machines around the clock as long as it is previously scheduled. We schedule our inspections seven days a week. Our rates change for inspections starting at 6 pm as well as inspections scheduled on Holidays, Saturday and Sundays."
    },
    {
      "question": "What payment methods do you accept?",
      "answer": "We accept credit cards, EFT, and Checks. Credit card payments can be paid directly through the QuickBooks email you receive after an inspection is completed."
    },
    // {
    //   "question": "How can I contact customer service for further assistance?",
    //   "answer": "You can contact our customer service by emailing us at inspection@hescocrane.com or by calling our office at 860-739-4446."
    // },
    {
      "question": "Can you provide an Inspection Estimate?",
      "answer": "We can provide an estimate prior to performing the inspection. You can request an inspection estimate by calling our office at 860-739-4446 and describing the details of the inspection or email us Inspection@hescocrane.com requesting an inspection estimate. You must include the following details for us to provide an accurate estimate. However, the estimate will only provide a predicted cost of the job, there are variables such as traffic or client-side delays that can lead to a difference in the actual billable time."
    },
    {
      "question": "How do I sign up to access my inspection documents?",
      "answer": "Register for an account at www.hescocrane.com and click the LOG IN button. We will approve the registration, and all company documents will be sent to you. You can also access your inspection documents directly in the portal under the ACTIVE CERTIFICATES section."
    },
    {
      "question": "How do I see my outstanding Deficiency Reports?",
      "answer": "Log in to the HESCO Inspection Portal and click the RED OUTSTANDING DEFICIENCIES tab at the top of the page. This will show you a list of deficiencies that are still outstanding. Once the issues are mitigated, they can be signed & dated through the portal and submitted. Alternatively, you can print out the deficiency report, write the date when the deficiencies were corrected, witness, sign and date the form, and email it back to us at Inspection@hescocrane.com."
    },
    {
      "question": "Where do I access my certificates? Deficiency reports? Can I download them? Can I print them? How do I share them?",
      "answer": "1. You can access your documents by logging into the Crane Inspection Portal or\n 2. you can access them by clicking the link in the email sent to you after the inspection documents have been processed by our office."    },
    {
      "question": "What if I need to schedule an inspection on behalf of another company?",
      "answer": "Contact our office at 860-739-4446 and describe the details of the inspection. Or you can email our office at Inspection@hescocrane.com and tell us to whom we will issue the inspection documents as well as who we are to bill for the inspection."
    }

  ];

  // Function to handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  return (
    <>
      <section className="profile-main pt-4 dashboard-content faq-content">
        <Container className="">
          <Row>
            <Col md={6} lg={6}>
              <h1 className="fs-30 fw-bold mb-1 mt-2">FAQ</h1>
              <p className="fs-15 ">Get Answers of Frequent Queries</p>
            </Col>
            <Col md={6} lg={6} className="align-items-start col-lg-6 col-md-6 d-flex justify-content-md-end mb-lg-0 mb-3">
              <div className="position-relative">
                <i className="fa fa-search faq-serach-icon" aria-hidden="true"></i>
                <input type="text" className="form-control mx-300 bg-transparent border-dark faq-search-input" value={searchQuery}
                  onChange={handleSearchChange} placeholder="Search Question" />
              </div>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col md={12} lg={12}>
              <Accordion className="faq-accordion" defaultActiveKey="0">

                {accordionItems.map((item, index) => {
                  // Apply the search filter
                  if (searchQuery && !item.question.toLowerCase().includes(searchQuery.toLowerCase())) {
                    return null; // Skip rendering the item if it doesn't match the search query
                  }

                  return (
                    <Accordion.Item key={index} eventKey={index.toString()}>
                      <Accordion.Header>
                        <svg id="ic_add_box_24px" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path id="Path_9183" data-name="Path 9183" d="M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3ZM17,13H13v4H11V13H7V11h4V7h2v4h4Z" fill="#cbcbcb" />
                          <path id="Path_9184" data-name="Path 9184" d="M0,0H24V24H0Z" fill="none" />
                        </svg>
                        {item.question}
                      </Accordion.Header>
                      <Accordion.Body>
                        <pre className="preline">{item.answer}</pre>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}

              </Accordion>

            </Col>
          </Row>

        </Container>
      </section>


    </>
  );
};
